function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function cov_1mrxvej1yn() {
  var path = "/app/src/components/long-term-content/long-term-content.tsx";
  var hash = "c1d1166b7f6a61c23269232745a01126f4694390";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/long-term-content/long-term-content.tsx",
    statementMap: {
      "0": {
        start: {
          line: 48,
          column: 6
        },
        end: {
          line: 48,
          column: 21
        }
      },
      "1": {
        start: {
          line: 50,
          column: 12
        },
        end: {
          line: 50,
          column: 23
        }
      },
      "2": {
        start: {
          line: 51,
          column: 18
        },
        end: {
          line: 51,
          column: 51
        }
      },
      "3": {
        start: {
          line: 52,
          column: 23
        },
        end: {
          line: 52,
          column: 58
        }
      },
      "4": {
        start: {
          line: 53,
          column: 33
        },
        end: {
          line: 53,
          column: 55
        }
      },
      "5": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 54
        }
      },
      "6": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 59
        }
      },
      "7": {
        start: {
          line: 59,
          column: 21
        },
        end: {
          line: 62,
          column: 3
        }
      },
      "8": {
        start: {
          line: 63,
          column: 26
        },
        end: {
          line: 63,
          column: 48
        }
      },
      "9": {
        start: {
          line: 64,
          column: 31
        },
        end: {
          line: 64,
          column: 77
        }
      },
      "10": {
        start: {
          line: 65,
          column: 40
        },
        end: {
          line: 65,
          column: 71
        }
      },
      "11": {
        start: {
          line: 66,
          column: 31
        },
        end: {
          line: 66,
          column: 47
        }
      },
      "12": {
        start: {
          line: 68,
          column: 33
        },
        end: {
          line: 75,
          column: 3
        }
      },
      "13": {
        start: {
          line: 70,
          column: 6
        },
        end: {
          line: 72,
          column: 35
        }
      },
      "14": {
        start: {
          line: 77,
          column: 29
        },
        end: {
          line: 77,
          column: 60
        }
      },
      "15": {
        start: {
          line: 79,
          column: 32
        },
        end: {
          line: 282,
          column: 3
        }
      },
      "16": {
        start: {
          line: 80,
          column: 18
        },
        end: {
          line: 82,
          column: 36
        }
      },
      "17": {
        start: {
          line: 83,
          column: 17
        },
        end: {
          line: 83,
          column: 37
        }
      },
      "18": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 142,
          column: 5
        }
      },
      "19": {
        start: {
          line: 87,
          column: 8
        },
        end: {
          line: 87,
          column: 55
        }
      },
      "20": {
        start: {
          line: 89,
          column: 6
        },
        end: {
          line: 141,
          column: 9
        }
      },
      "21": {
        start: {
          line: 98,
          column: 12
        },
        end: {
          line: 98,
          column: 16
        }
      },
      "22": {
        start: {
          line: 100,
          column: 29
        },
        end: {
          line: 109,
          column: 9
        }
      },
      "23": {
        start: {
          line: 107,
          column: 28
        },
        end: {
          line: 107,
          column: 60
        }
      },
      "24": {
        start: {
          line: 110,
          column: 27
        },
        end: {
          line: 112,
          column: 16
        }
      },
      "25": {
        start: {
          line: 114,
          column: 25
        },
        end: {
          line: 123,
          column: 10
        }
      },
      "26": {
        start: {
          line: 125,
          column: 34
        },
        end: {
          line: 127,
          column: 16
        }
      },
      "27": {
        start: {
          line: 129,
          column: 8
        },
        end: {
          line: 140,
          column: 10
        }
      },
      "28": {
        start: {
          line: 144,
          column: 4
        },
        end: {
          line: 281,
          column: 48
        }
      },
      "29": {
        start: {
          line: 161,
          column: 28
        },
        end: {
          line: 161,
          column: 60
        }
      },
      "30": {
        start: {
          line: 182,
          column: 28
        },
        end: {
          line: 182,
          column: 60
        }
      },
      "31": {
        start: {
          line: 199,
          column: 28
        },
        end: {
          line: 199,
          column: 60
        }
      },
      "32": {
        start: {
          line: 220,
          column: 28
        },
        end: {
          line: 220,
          column: 60
        }
      },
      "33": {
        start: {
          line: 237,
          column: 28
        },
        end: {
          line: 237,
          column: 60
        }
      },
      "34": {
        start: {
          line: 258,
          column: 28
        },
        end: {
          line: 258,
          column: 60
        }
      },
      "35": {
        start: {
          line: 275,
          column: 28
        },
        end: {
          line: 275,
          column: 60
        }
      },
      "36": {
        start: {
          line: 284,
          column: 19
        },
        end: {
          line: 297,
          column: 3
        }
      },
      "37": {
        start: {
          line: 285,
          column: 4
        },
        end: {
          line: 285,
          column: 18
        }
      },
      "38": {
        start: {
          line: 287,
          column: 4
        },
        end: {
          line: 296,
          column: 5
        }
      },
      "39": {
        start: {
          line: 288,
          column: 6
        },
        end: {
          line: 295,
          column: 9
        }
      },
      "40": {
        start: {
          line: 299,
          column: 2
        },
        end: {
          line: 385,
          column: 4
        }
      },
      "41": {
        start: {
          line: 327,
          column: 14
        },
        end: {
          line: 327,
          column: 51
        }
      }
    },
    fnMap: {
      "0": {
        name: "LongTermContent",
        decl: {
          start: {
            line: 39,
            column: 16
          },
          end: {
            line: 39,
            column: 31
          }
        },
        loc: {
          start: {
            line: 39,
            column: 64
          },
          end: {
            line: 386,
            column: 1
          }
        },
        line: 39
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 69,
            column: 5
          }
        },
        loc: {
          start: {
            line: 69,
            column: 47
          },
          end: {
            line: 73,
            column: 5
          }
        },
        line: 69
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 79,
            column: 32
          },
          end: {
            line: 79,
            column: 33
          }
        },
        loc: {
          start: {
            line: 79,
            column: 62
          },
          end: {
            line: 282,
            column: 3
          }
        },
        line: 79
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 89,
            column: 64
          },
          end: {
            line: 89,
            column: 65
          }
        },
        loc: {
          start: {
            line: 89,
            column: 79
          },
          end: {
            line: 141,
            column: 7
          }
        },
        line: 89
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 107,
            column: 22
          },
          end: {
            line: 107,
            column: 23
          }
        },
        loc: {
          start: {
            line: 107,
            column: 28
          },
          end: {
            line: 107,
            column: 60
          }
        },
        line: 107
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 161,
            column: 22
          },
          end: {
            line: 161,
            column: 23
          }
        },
        loc: {
          start: {
            line: 161,
            column: 28
          },
          end: {
            line: 161,
            column: 60
          }
        },
        line: 161
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 182,
            column: 22
          },
          end: {
            line: 182,
            column: 23
          }
        },
        loc: {
          start: {
            line: 182,
            column: 28
          },
          end: {
            line: 182,
            column: 60
          }
        },
        line: 182
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 199,
            column: 22
          },
          end: {
            line: 199,
            column: 23
          }
        },
        loc: {
          start: {
            line: 199,
            column: 28
          },
          end: {
            line: 199,
            column: 60
          }
        },
        line: 199
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 220,
            column: 22
          },
          end: {
            line: 220,
            column: 23
          }
        },
        loc: {
          start: {
            line: 220,
            column: 28
          },
          end: {
            line: 220,
            column: 60
          }
        },
        line: 220
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 237,
            column: 22
          },
          end: {
            line: 237,
            column: 23
          }
        },
        loc: {
          start: {
            line: 237,
            column: 28
          },
          end: {
            line: 237,
            column: 60
          }
        },
        line: 237
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 258,
            column: 22
          },
          end: {
            line: 258,
            column: 23
          }
        },
        loc: {
          start: {
            line: 258,
            column: 28
          },
          end: {
            line: 258,
            column: 60
          }
        },
        line: 258
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 275,
            column: 22
          },
          end: {
            line: 275,
            column: 23
          }
        },
        loc: {
          start: {
            line: 275,
            column: 28
          },
          end: {
            line: 275,
            column: 60
          }
        },
        line: 275
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 284,
            column: 19
          },
          end: {
            line: 284,
            column: 20
          }
        },
        loc: {
          start: {
            line: 284,
            column: 36
          },
          end: {
            line: 297,
            column: 3
          }
        },
        line: 284
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 326,
            column: 43
          },
          end: {
            line: 326,
            column: 44
          }
        },
        loc: {
          start: {
            line: 327,
            column: 14
          },
          end: {
            line: 327,
            column: 51
          }
        },
        line: 327
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 42,
            column: 28
          },
          end: {
            line: 42,
            column: 51
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 42,
            column: 49
          },
          end: {
            line: 42,
            column: 51
          }
        }],
        line: 42
      },
      "1": {
        loc: {
          start: {
            line: 52,
            column: 24
          },
          end: {
            line: 52,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 52,
            column: 24
          },
          end: {
            line: 52,
            column: 29
          }
        }, {
          start: {
            line: 52,
            column: 33
          },
          end: {
            line: 52,
            column: 46
          }
        }],
        line: 52
      },
      "2": {
        loc: {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 57,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 57,
            column: 26
          }
        }, {
          start: {
            line: 57,
            column: 30
          },
          end: {
            line: 57,
            column: 59
          }
        }],
        line: 57
      },
      "3": {
        loc: {
          start: {
            line: 64,
            column: 31
          },
          end: {
            line: 64,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 64,
            column: 61
          },
          end: {
            line: 64,
            column: 69
          }
        }, {
          start: {
            line: 64,
            column: 72
          },
          end: {
            line: 64,
            column: 77
          }
        }],
        line: 64
      },
      "4": {
        loc: {
          start: {
            line: 64,
            column: 31
          },
          end: {
            line: 64,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 64,
            column: 31
          },
          end: {
            line: 64,
            column: 39
          }
        }, {
          start: {
            line: 64,
            column: 43
          },
          end: {
            line: 64,
            column: 58
          }
        }],
        line: 64
      },
      "5": {
        loc: {
          start: {
            line: 70,
            column: 13
          },
          end: {
            line: 72,
            column: 34
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 71,
            column: 10
          },
          end: {
            line: 71,
            column: 21
          }
        }, {
          start: {
            line: 72,
            column: 10
          },
          end: {
            line: 72,
            column: 34
          }
        }],
        line: 70
      },
      "6": {
        loc: {
          start: {
            line: 80,
            column: 18
          },
          end: {
            line: 82,
            column: 36
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 81,
            column: 26
          }
        }, {
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 82,
            column: 36
          }
        }],
        line: 80
      },
      "7": {
        loc: {
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 142,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 142,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 85
      },
      "8": {
        loc: {
          start: {
            line: 110,
            column: 27
          },
          end: {
            line: 112,
            column: 16
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 111,
            column: 12
          },
          end: {
            line: 111,
            column: 51
          }
        }, {
          start: {
            line: 112,
            column: 12
          },
          end: {
            line: 112,
            column: 16
          }
        }],
        line: 110
      },
      "9": {
        loc: {
          start: {
            line: 125,
            column: 34
          },
          end: {
            line: 127,
            column: 16
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 126,
            column: 10
          },
          end: {
            line: 126,
            column: 44
          }
        }, {
          start: {
            line: 127,
            column: 12
          },
          end: {
            line: 127,
            column: 16
          }
        }],
        line: 125
      },
      "10": {
        loc: {
          start: {
            line: 136,
            column: 27
          },
          end: {
            line: 136,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 136,
            column: 27
          },
          end: {
            line: 136,
            column: 44
          }
        }, {
          start: {
            line: 136,
            column: 48
          },
          end: {
            line: 136,
            column: 59
          }
        }],
        line: 136
      },
      "11": {
        loc: {
          start: {
            line: 137,
            column: 30
          },
          end: {
            line: 137,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 137,
            column: 30
          },
          end: {
            line: 137,
            column: 48
          }
        }, {
          start: {
            line: 137,
            column: 52
          },
          end: {
            line: 137,
            column: 74
          }
        }],
        line: 137
      },
      "12": {
        loc: {
          start: {
            line: 151,
            column: 10
          },
          end: {
            line: 153,
            column: 49
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 152,
            column: 14
          },
          end: {
            line: 152,
            column: 55
          }
        }, {
          start: {
            line: 153,
            column: 14
          },
          end: {
            line: 153,
            column: 49
          }
        }],
        line: 151
      },
      "13": {
        loc: {
          start: {
            line: 151,
            column: 10
          },
          end: {
            line: 151,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 151,
            column: 10
          },
          end: {
            line: 151,
            column: 27
          }
        }, {
          start: {
            line: 151,
            column: 31
          },
          end: {
            line: 151,
            column: 50
          }
        }],
        line: 151
      },
      "14": {
        loc: {
          start: {
            line: 287,
            column: 4
          },
          end: {
            line: 296,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 287,
            column: 4
          },
          end: {
            line: 296,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 287
      },
      "15": {
        loc: {
          start: {
            line: 306,
            column: 12
          },
          end: {
            line: 306,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 306,
            column: 12
          },
          end: {
            line: 306,
            column: 49
          }
        }, {
          start: {
            line: 306,
            column: 53
          },
          end: {
            line: 306,
            column: 77
          }
        }],
        line: 306
      },
      "16": {
        loc: {
          start: {
            line: 315,
            column: 9
          },
          end: {
            line: 322,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 315,
            column: 9
          },
          end: {
            line: 315,
            column: 29
          }
        }, {
          start: {
            line: 316,
            column: 10
          },
          end: {
            line: 321,
            column: 12
          }
        }],
        line: 315
      },
      "17": {
        loc: {
          start: {
            line: 324,
            column: 9
          },
          end: {
            line: 338,
            column: 9
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 325,
            column: 10
          },
          end: {
            line: 329,
            column: 16
          }
        }, {
          start: {
            line: 331,
            column: 10
          },
          end: {
            line: 337,
            column: 16
          }
        }],
        line: 324
      },
      "18": {
        loc: {
          start: {
            line: 345,
            column: 7
          },
          end: {
            line: 371,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 345,
            column: 7
          },
          end: {
            line: 345,
            column: 22
          }
        }, {
          start: {
            line: 346,
            column: 8
          },
          end: {
            line: 370,
            column: 11
          }
        }],
        line: 345
      },
      "19": {
        loc: {
          start: {
            line: 347,
            column: 11
          },
          end: {
            line: 362,
            column: 11
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 348,
            column: 12
          },
          end: {
            line: 355,
            column: 14
          }
        }, {
          start: {
            line: 357,
            column: 12
          },
          end: {
            line: 361,
            column: 14
          }
        }],
        line: 347
      },
      "20": {
        loc: {
          start: {
            line: 373,
            column: 7
          },
          end: {
            line: 381,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 373,
            column: 7
          },
          end: {
            line: 373,
            column: 19
          }
        }, {
          start: {
            line: 374,
            column: 8
          },
          end: {
            line: 380,
            column: 17
          }
        }],
        line: 373
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c1d1166b7f6a61c23269232745a01126f4694390"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1mrxvej1yn = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1mrxvej1yn();
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import cn from 'classnames';
import React, { useState } from 'react';
import { CreditCards } from 'src/components/credit-cards';
import { Currency } from 'src/components/currency';
import { InstallmentsInput } from 'src/components/installments-input';
import { LearnMoreHowItWorks } from 'src/components/learn-more-how-it-works';
import { PayNextMonthTab } from 'src/components/pay-next-month-tab';
import { PopupLearnMoreBackgroundHeader } from 'src/components/popup-learn-more-background-header';
import { TrustBanner } from 'src/components/trust-banner';
import { Button } from 'src/components/v2/button';
import { ACTIONS } from 'src/constants/common';
import { COUNTRY_BY_CURRENCY_MAP } from 'src/constants/country-by-currency-map';
import { INITIAL_PRICE, INSTALLMENT_PLANS } from 'src/constants/learn-more';
import { useAppContext } from 'src/context/store/app-provider';
import { useLocale } from 'src/hooks/use-locale';
import { createNormalizeCheckingNumber } from 'src/utils/create-normalize-checking-number';
import { calculateFeesByPrice, calculatePriceWithFees } from 'src/utils/default-fees-calculator';
import { getFormattedAmount } from 'src/utils/get-formatted-amount';
import { getInstallmentPeriod } from 'src/utils/get-installment-period';
import { getPriceSplitOf } from 'src/utils/get-price-split-of';
import { InstallmentItem } from './components/installment-item';
import { InstallmentItemSkeleton } from './components/installment-item-skeleton';
import { SubventionFaqLink } from './components/subvention-faq-link';
import styles from './styles.css';
import { getFeesDescription, getSortedInstallmentsOffers } from './utils';
export function LongTermContent(_ref) {
  var _ref6;
  var onClose = _ref.onClose,
    onContinue = _ref.onContinue;
  cov_1mrxvej1yn().f[0]++;
  var _ref2 = (cov_1mrxvej1yn().s[0]++, useAppContext()),
    _currency = _ref2.currency,
    _ref2$offers$installm = _ref2.offers.installments,
    offersInstallments = _ref2$offers$installm === void 0 ? (cov_1mrxvej1yn().b[0][0]++, []) : _ref2$offers$installm,
    priceRaw = _ref2.priceRaw,
    price = _ref2.price,
    getExperiment = _ref2.getExperiment,
    loading = _ref2.loading,
    dispatch = _ref2.dispatch;
  var t = (cov_1mrxvej1yn().s[1]++, useLocale());
  var country = (cov_1mrxvej1yn().s[2]++, COUNTRY_BY_CURRENCY_MAP[_currency]);
  var initialValue = (cov_1mrxvej1yn().s[3]++, ((cov_1mrxvej1yn().b[1][0]++, price) || (cov_1mrxvej1yn().b[1][1]++, INITIAL_PRICE)).toString());
  var _ref3 = (cov_1mrxvej1yn().s[4]++, useState(initialValue)),
    _ref4 = _slicedToArray(_ref3, 2),
    inputValue = _ref4[0],
    setValue = _ref4[1];
  var isPlansSwitcherEnabled = (cov_1mrxvej1yn().s[5]++, getExperiment('CT-3300-plans-switcher') === 'test');
  var isPlanSwitcher = (cov_1mrxvej1yn().s[6]++, (cov_1mrxvej1yn().b[2][0]++, isPlansSwitcherEnabled) && (cov_1mrxvej1yn().b[2][1]++, offersInstallments.length > 1));
  var checkPrice = (cov_1mrxvej1yn().s[7]++, createNormalizeCheckingNumber('Price argument is not a number', 0));
  var isRawPriceValid = (cov_1mrxvej1yn().s[8]++, !!checkPrice(priceRaw));
  var initialPreparedPrice = (cov_1mrxvej1yn().s[9]++, (cov_1mrxvej1yn().b[4][0]++, priceRaw) && (cov_1mrxvej1yn().b[4][1]++, isRawPriceValid) ? (cov_1mrxvej1yn().b[3][0]++, priceRaw) : (cov_1mrxvej1yn().b[3][1]++, price));
  var merchantHasPreConfiguredPlans = (cov_1mrxvej1yn().s[10]++, offersInstallments.length !== 0);
  var isCalculationEnabled = (cov_1mrxvej1yn().s[11]++, !isRawPriceValid);
  var longestInstallmentPlan = (cov_1mrxvej1yn().s[12]++, offersInstallments.reduce(function (maxInstallmentPeriodPlan, installment) {
    cov_1mrxvej1yn().f[1]++;
    cov_1mrxvej1yn().s[13]++;
    return installment.paymentsCount > maxInstallmentPeriodPlan.paymentsCount ? (cov_1mrxvej1yn().b[5][0]++, installment) : (cov_1mrxvej1yn().b[5][1]++, maxInstallmentPeriodPlan);
  }, offersInstallments[0]));
  var hasConfiguredPlans = (cov_1mrxvej1yn().s[14]++, offersInstallments.length !== 0);
  cov_1mrxvej1yn().s[15]++;
  var getInstallmentOptions = function getInstallmentOptions() {
    cov_1mrxvej1yn().f[2]++;
    var value = (cov_1mrxvej1yn().s[16]++, isCalculationEnabled ? (cov_1mrxvej1yn().b[6][0]++, Number(inputValue)) : (cov_1mrxvej1yn().b[6][1]++, Number(initialPreparedPrice)));
    var list = (cov_1mrxvej1yn().s[17]++, isCalculationEnabled);
    cov_1mrxvej1yn().s[18]++;
    if (merchantHasPreConfiguredPlans) {
      cov_1mrxvej1yn().b[7][0]++;
      var sortedInstallmentsOffers = (cov_1mrxvej1yn().s[19]++, getSortedInstallmentsOffers(offersInstallments));
      cov_1mrxvej1yn().s[20]++;
      return sortedInstallmentsOffers.map(function (item, idx) {
        cov_1mrxvej1yn().f[3]++;
        var _ref5 = (cov_1mrxvej1yn().s[21]++, item),
          amount = _ref5.amount,
          paymentsCount = _ref5.paymentsCount,
          period = _ref5.period,
          totalFees = _ref5.totalFees,
          serviceFeePolicy = _ref5.serviceFeePolicy,
          isLimitedTimeOffer = _ref5.isLimitedTimeOffer,
          subventionCampaignId = _ref5.subventionCampaignId;
        var paymentsInfo = (cov_1mrxvej1yn().s[22]++, t('paid_plans.payment_per_period', {
          price: getFormattedAmount(amount, _currency),
          period: getInstallmentPeriod(t, period)
        }, {
          currency: function currency() {
            cov_1mrxvej1yn().f[4]++;
            cov_1mrxvej1yn().s[23]++;
            return /*#__PURE__*/React.createElement(Currency, {
              currency: _currency
            });
          }
        }));
        var feesAmount = (cov_1mrxvej1yn().s[24]++, totalFees ? (cov_1mrxvej1yn().b[8][0]++, getFormattedAmount(totalFees, _currency)) : (cov_1mrxvej1yn().b[8][1]++, null));
        var subtitle = (cov_1mrxvej1yn().s[25]++, getFeesDescription({
          feesAmount: feesAmount,
          totalFees: totalFees,
          serviceFeePolicy: serviceFeePolicy,
          currency: _currency,
          period: period,
          fullAmount: value,
          paymentsCount: paymentsCount,
          t: t
        }));
        var additionalContent = (cov_1mrxvej1yn().s[26]++, subventionCampaignId ? (cov_1mrxvej1yn().b[9][0]++, /*#__PURE__*/React.createElement(SubventionFaqLink, {
          offer: item
        })) : (cov_1mrxvej1yn().b[9][1]++, null));
        cov_1mrxvej1yn().s[27]++;
        return {
          key: idx,
          title: t('payments_other', {
            installmentsCount: paymentsCount
          }),
          subtitle: subtitle,
          paymentsInfo: paymentsInfo,
          isGreenSubtitle: (cov_1mrxvej1yn().b[10][0]++, country !== 'KSA') && (cov_1mrxvej1yn().b[10][1]++, !feesAmount),
          isLimitedTimeOffer: (cov_1mrxvej1yn().b[11][0]++, isLimitedTimeOffer) || (cov_1mrxvej1yn().b[11][1]++, !!subventionCampaignId),
          additionalContent: additionalContent,
          list: list
        };
      });
    } else {
      cov_1mrxvej1yn().b[7][1]++;
    }
    cov_1mrxvej1yn().s[28]++;
    return [{
      key: INSTALLMENT_PLANS.four,
      title: t('payments_other', {
        installmentsCount: INSTALLMENT_PLANS.four
      }),
      subtitle: (cov_1mrxvej1yn().b[13][0]++, country === 'KSA') && (cov_1mrxvej1yn().b[13][1]++, !hasConfiguredPlans) ? (cov_1mrxvej1yn().b[12][0]++, t('no_interest_processing_fee_may_apply')) : (cov_1mrxvej1yn().b[12][1]++, t('paid_plans.no_interest_no_fees')),
      paymentsInfo: t('paid_plans.payment_per_period', {
        price: getPriceSplitOf(value, _currency, INSTALLMENT_PLANS.four),
        period: t('period')
      }, {
        currency: function currency() {
          cov_1mrxvej1yn().f[5]++;
          cov_1mrxvej1yn().s[29]++;
          return /*#__PURE__*/React.createElement(Currency, {
            currency: _currency
          });
        }
      }),
      isGreenSubtitle: country !== 'KSA',
      list: list
    }, {
      key: INSTALLMENT_PLANS.six,
      title: t('payments_other', {
        installmentsCount: INSTALLMENT_PLANS.six
      }),
      subtitle: t('paid_plans.service_fee_in_total', {
        serviceFee: calculateFeesByPrice(value, INSTALLMENT_PLANS.six, _currency)
      }, {
        currency: function currency() {
          cov_1mrxvej1yn().f[6]++;
          cov_1mrxvej1yn().s[30]++;
          return /*#__PURE__*/React.createElement(Currency, {
            currency: _currency
          });
        }
      }),
      paymentsInfo: t('paid_plans.payment_per_period', {
        price: getPriceSplitOf(calculatePriceWithFees({
          price: value,
          installmentCount: INSTALLMENT_PLANS.six
        }), _currency, INSTALLMENT_PLANS.six),
        period: t('period')
      }, {
        currency: function currency() {
          cov_1mrxvej1yn().f[7]++;
          cov_1mrxvej1yn().s[31]++;
          return /*#__PURE__*/React.createElement(Currency, {
            currency: _currency
          });
        }
      }),
      isGreenSubtitle: false,
      list: list
    }, {
      key: INSTALLMENT_PLANS.eight,
      title: t('payments_other', {
        installmentsCount: INSTALLMENT_PLANS.eight
      }),
      subtitle: t('paid_plans.service_fee_in_total', {
        serviceFee: calculateFeesByPrice(value, INSTALLMENT_PLANS.eight, _currency)
      }, {
        currency: function currency() {
          cov_1mrxvej1yn().f[8]++;
          cov_1mrxvej1yn().s[32]++;
          return /*#__PURE__*/React.createElement(Currency, {
            currency: _currency
          });
        }
      }),
      paymentsInfo: t('paid_plans.payment_per_period', {
        price: getPriceSplitOf(calculatePriceWithFees({
          price: value,
          installmentCount: INSTALLMENT_PLANS.eight
        }), _currency, INSTALLMENT_PLANS.eight),
        period: t('period')
      }, {
        currency: function currency() {
          cov_1mrxvej1yn().f[9]++;
          cov_1mrxvej1yn().s[33]++;
          return /*#__PURE__*/React.createElement(Currency, {
            currency: _currency
          });
        }
      }),
      isGreenSubtitle: false,
      list: list
    }, {
      key: INSTALLMENT_PLANS.twelve,
      title: t('payments_other', {
        installmentsCount: INSTALLMENT_PLANS.twelve
      }),
      subtitle: t('paid_plans.service_fee_in_total', {
        serviceFee: calculateFeesByPrice(value, INSTALLMENT_PLANS.twelve, _currency)
      }, {
        currency: function currency() {
          cov_1mrxvej1yn().f[10]++;
          cov_1mrxvej1yn().s[34]++;
          return /*#__PURE__*/React.createElement(Currency, {
            currency: _currency
          });
        }
      }),
      paymentsInfo: t('paid_plans.payment_per_period', {
        price: getPriceSplitOf(calculatePriceWithFees({
          price: value,
          installmentCount: INSTALLMENT_PLANS.twelve
        }), _currency, INSTALLMENT_PLANS.twelve),
        period: t('period')
      }, {
        currency: function currency() {
          cov_1mrxvej1yn().f[11]++;
          cov_1mrxvej1yn().s[35]++;
          return /*#__PURE__*/React.createElement(Currency, {
            currency: _currency
          });
        }
      }),
      isGreenSubtitle: false,
      list: list
    }].filter(Boolean);
  };
  cov_1mrxvej1yn().s[36]++;
  var onChange = function onChange(val) {
    cov_1mrxvej1yn().f[12]++;
    cov_1mrxvej1yn().s[37]++;
    setValue(val);
    cov_1mrxvej1yn().s[38]++;
    if (merchantHasPreConfiguredPlans) {
      cov_1mrxvej1yn().b[14][0]++;
      cov_1mrxvej1yn().s[39]++;
      dispatch({
        type: ACTIONS.UPDATE_STORE,
        payload: {
          loading: true,
          price: Number(val),
          skipRawPriceUpdate: true
        }
      });
    } else {
      cov_1mrxvej1yn().b[14][1]++;
    }
  };
  cov_1mrxvej1yn().s[40]++;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(PopupLearnMoreBackgroundHeader, {
    onClose: onClose,
    title: t('paid_plans.get_more_time_to_pay'),
    subtitle: t('paid_plans.split_your_purchase', {
      installmentsCount: (_ref6 = (cov_1mrxvej1yn().b[15][0]++, longestInstallmentPlan === null || longestInstallmentPlan === void 0 ? void 0 : longestInstallmentPlan.paymentsCount)) !== null && _ref6 !== void 0 ? _ref6 : (cov_1mrxvej1yn().b[15][1]++, INSTALLMENT_PLANS.twelve)
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: cn(_defineProperty({}, styles.inputContainer, isCalculationEnabled))
  }, (cov_1mrxvej1yn().b[16][0]++, isCalculationEnabled) && (cov_1mrxvej1yn().b[16][1]++, /*#__PURE__*/React.createElement(InstallmentsInput, {
    id: "long-term-input",
    value: inputValue,
    onChange: onChange,
    className: styles.input
  })), loading ? (cov_1mrxvej1yn().b[17][0]++, /*#__PURE__*/React.createElement("div", {
    className: styles.loading
  }, Array.from({
    length: 4
  }).map(function (_, idx) {
    cov_1mrxvej1yn().f[13]++;
    cov_1mrxvej1yn().s[41]++;
    return /*#__PURE__*/React.createElement(InstallmentItemSkeleton, {
      key: idx
    });
  }))) : (cov_1mrxvej1yn().b[17][1]++, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.paymentOptions, _defineProperty({}, styles.paymentOptionsList, isCalculationEnabled))
  }, getInstallmentOptions().map(InstallmentItem)))), /*#__PURE__*/React.createElement(PayNextMonthTab, null), /*#__PURE__*/React.createElement(LearnMoreHowItWorks, null), (cov_1mrxvej1yn().b[18][0]++, !isPlanSwitcher) && (cov_1mrxvej1yn().b[18][1]++, /*#__PURE__*/React.createElement(React.Fragment, null, country === 'KSA' ? (cov_1mrxvej1yn().b[19][0]++, /*#__PURE__*/React.createElement(TrustBanner, {
    title: t('shariah_compliant_payments'),
    description: t('our_payment_options_meet_islamic_finance_standards'),
    icon: "shariat-modern",
    iconClassName: styles.bannerIcon
  })) : (cov_1mrxvej1yn().b[19][1]++, /*#__PURE__*/React.createElement(TrustBanner, {
    title: t('tabby_trusted.trusted_by_milions'),
    description: t('over_20_million_shoppers_pay_with_tabby'),
    icon: "people"
  })), /*#__PURE__*/React.createElement(TrustBanner, {
    title: t('tabby_care.show_safely'),
    description: t('tabby_care.buyer_protection_included'),
    icon: "tabby-care",
    className: styles.tabbyCare
  }))), (cov_1mrxvej1yn().b[20][0]++, !!onContinue) && (cov_1mrxvej1yn().b[20][1]++, /*#__PURE__*/React.createElement(Button, {
    onClick: onContinue,
    "data-test": "continue-shopping",
    className: styles.button
  }, t('tabbySplit.continue_shopping'))), /*#__PURE__*/React.createElement(CreditCards, {
    country: country,
    fullWidth: true
  }));
}